
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCurrent1 as ObiCurrent1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-current-1.js';
 
 
 

 
 export const ObiCurrent1 = createComponent({
   react: React,
   tagName: 'obi-current-1',
   elementClass: ObiCurrent1Element,
   events: {
     
   }
  });
 
 